import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const getInvestorToken = () => localStorage.getItem("investor_token");
export const getAdminToken = () => localStorage.getItem("admin_token");

export const authHeaders = () => {
  const admin = getAdminToken();
  if (admin) return { "X-Admin-Token": admin };
  const token = getInvestorToken();
  if (token) return { Authorization: `Bearer ${token}` };
  return {};
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  config.headers = { ...config.headers, ...authHeaders() };
  return config;
});

export const fileUrl = (fileId) => {
  const admin = getAdminToken();
  const token = getInvestorToken();
  const q = admin ? `admin=${encodeURIComponent(admin)}` : `token=${encodeURIComponent(token)}`;
  return `${API}/files/${fileId}/download?${q}`;
};

export const teamPhotoUrl = (memberId) => {
  const admin = getAdminToken();
  const token = getInvestorToken();
  const q = admin ? `admin=${encodeURIComponent(admin)}` : `token=${encodeURIComponent(token)}`;
  return `${API}/team/members/${memberId}/photo?${q}&t=${Date.now()}`;
};

export async function openFile(file) {
  const res = await fetch(fileUrl(file.id), { headers: authHeaders() });
  if (!res.ok) throw new Error("Unable to open file");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
